import EventDescr from './descr';
import EventLocation from './googleSearchbox';
import EventTimeZone from './timeZone';
import EventDates from './dates';
import EventPicture from './picture';
import EventDetailsAdvSet from './eventDetailsAdvSet';

const Forms = {
  EventDescr,
  EventLocation,
  EventTimeZone,
  EventDates,
  EventPicture,
  EventDetailsAdvSet
};

export default Forms;
